import { render, staticRenderFns } from "./compras-gasoinfo.vue?vue&type=template&id=06a546ca&scoped=true&"
import script from "./compras-gasoinfo.vue?vue&type=script&lang=js&"
export * from "./compras-gasoinfo.vue?vue&type=script&lang=js&"
import style0 from "./compras-gasoinfo.vue?vue&type=style&index=0&id=06a546ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a546ca",
  null
  
)

export default component.exports